/**
 * Generated by orval - Do not edit manually.
 * Buildertrend API (all versions)
 * A view showing all available versions of the API. Some routes may be deprecated. Use the latest version available whenever possible.
 * OpenAPI spec version: all
 * If there are merge conflicts to this file,
 * please rebuild the Clients.Api project to resolve.
 */

/**
 * Type enum to distinguish between selection options and allowances0 = Option

1 = Allowance

2 = AllowanceRemainder

3 = Group


 */
export type SelectionListItemType =
  (typeof SelectionListItemType)[keyof typeof SelectionListItemType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SelectionListItemType = {
  Option: 0,
  Allowance: 1,
  AllowanceRemainder: 2,
  Group: 3,
} as const;
